import React, { Component } from 'react'
import {path} from './Constant'; 
export default class PageNotFound extends Component {
    render() {
        return (
            <div  >
             <img className="center-image" src={path+"images/page_not_found.jpg"} alt="Page Not Found" /> 
            </div>
        )
    }
}
